import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from './../../../app.config';

@Injectable()
export class DeclarationsMetauxMachefersService {
    private urlGetRepreneursTonnages: string = '';
    private urlSaveMetauxMachefers: string = '';
    private urlPartnersByType: string = '';
    private urlGetTenneursMagnetique: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlGetRepreneursTonnages = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetRepreneursTonnages?idDett=';
        this.urlSaveMetauxMachefers = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/SaveMetauxValorisation?idDett=';
        this.urlPartnersByType = _appConfig.getConfig().nPointDeclarations + '/utom/GetPartnersByTypes?';
        this.urlGetTenneursMagnetique = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetTenneursMagnetique?idDett=';
    }

    getTenneursMagnetique(declaId): Observable<any> {
        return this.http.get(this.urlGetTenneursMagnetique + declaId)
            .catch(this.handleError);
    }

    getRepreneursTonnages(declaId, idTdd): Observable<any> {
        return this.http.get(this.urlGetRepreneursTonnages + declaId + '&idTdd=' + idTdd)
            .catch(this.handleError);
    }

    getPartnersByType(types: number[]): Observable<any> {
        const postUrl = types.map(num => 'idsTpn=' + num).join('&');
        return this.http.get(this.urlPartnersByType + postUrl)
            .catch(this.handleError);
    }

    saveMetauxMachefers(declaId, payload): Observable<any> {
        return this.http.post(this.urlSaveMetauxMachefers + declaId, payload)
            .catch(this.handleError);
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-declarations/services/declarations-metaux-machefers.service.ts